import React, { useEffect, useRef, forwardRef } from 'react';
import { debounce, isEndOfList } from '../../../Utils/scroll';

const Images = forwardRef(({ images, currentSlide, handleSlide }, ref) => {
  const wheelTimeout = useRef();

  const imagesLength = images.length;

  useEffect(() => {
    const cancelWheel = (e) => wheelTimeout.current && e.preventDefault();
    document.body.addEventListener('wheel', cancelWheel, { passive: false });

    return () => document.body.removeEventListener('wheel', cancelWheel);
  }, []);

  const preventDefault = () => {
    clearTimeout(wheelTimeout.current);
    wheelTimeout.current = setTimeout(() => {
      wheelTimeout.current = false;
    }, 250);
  };

  const scroll = (deltaY) => {
    const direction = Math.sign(deltaY);
    if (deltaY === 0 || isEndOfList(direction, currentSlide, imagesLength))
      return;

    handleSlide(direction);
  };

  const handleWheel = ({ deltaY }) => {
    preventDefault();
    debounce(() => scroll(deltaY), 100);
  };

  let deltaX = 0;
  let startX = 0;

  const handleTouchStart = (e) => {
    if (e.touches.length > 1) return;

    const { clientX } = e.touches[0];
    startX = clientX;
  };

  const handleTouchMove = (e) => {
    const { clientX } = e.touches[0];
    deltaX = startX - clientX;
    debounce(() => scroll(deltaX), 100);
  };

  const handleTouchEnd = (e) => {
    const { touches } = e;
  };

  const getImages = (() =>
    images.map(({ src }, k) => <img itemProp="image" width="680" src={src} key={k} id={k} />))();

  return (
    <div
      ref={ref}
      className="image-slider"
      onWheel={handleWheel}
      onTouchMove={handleTouchMove}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {getImages}
    </div>
  );
});

export default Images;
